import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { TypeParams } from '../../types'

import { Plugin } from './plugin'

/**
 * @see {@link Plugin}, {@link ec.plugins.Plugin.Factory}
 */
export class Factory
  implements ec.plugins.Plugin.Factory<TypeParams, typeof Plugin.id, Plugin>
{
  /** @see {@link Plugin.id} */
  public readonly id = Plugin.id

  /** Creates a {@link Plugin} for the given {@link ec.Collection} */
  public produceFor(collection: ec.Collection<TypeParams>): Plugin {
    return new Plugin({ collection })
  }
}
